import BaseViewController from "./base-view-controller";

class AddMedicationViewController extends BaseViewController {
  handleButtonClick() {
    const { data, screenIndex, values, screenParams, nextScreen, settings } =
      this.appData;
    const availIndex = Object.keys(values).reduce((availIndexNum, key) => {
      if (key.startsWith("mhd_answers.128")) {
        const index = parseInt(key.split(".")[2], 10);
        return index >= availIndexNum ? index + 1 : availIndexNum;
      } else {
        return availIndexNum;
      }
    }, 0);
    const availPrefix = `mhd_answers.128.${availIndex}`;
    const myMedicalHistory = data.screens.find(s =>
      (s.params || "").includes("TDScreenOptionMedicalHistory")
    );
    const addMedicineLinkIndex = myMedicalHistory.fields.findIndex(
      f => f.name === "addMedicineLink"
    );
    myMedicalHistory.fields = [
      ...myMedicalHistory.fields.slice(
        0,
        addMedicineLinkIndex + availIndex + 1
      ),
      {
        params:
          "TDFieldOptionIsMedicine|TDFieldOptionIsLast|TDFieldOptionAutoCorrectNone",
        name: `${availPrefix}.actively_taking_flg`,
        title: values.medication_name,
        type: "cellWithSubtitle",
        text: `${values.medication_dosage}, ${values.medication_frequency}`,
        options: [
          {
            name: "Y",
            text: settings.translations.currently_taking,
            value: "Y",
            selected: values.statusQuestion === "Y"
          },
          {
            name: "N",
            text: settings.translations.not_currently_taking,
            value: "N",
            selected: values.statusQuestion === "N"
          }
        ]
      },
      ...myMedicalHistory.fields.slice(addMedicineLinkIndex + availIndex + 1)
    ].filter(f => f.name !== "mhd_answers.128");
    nextScreen({
      data,
      screenIndex,
      formState: {
        ...values,
        [`${availPrefix}.drug_nm`]: values.medication_name,
        [`${availPrefix}.drug_cd`]: screenParams.drug_cd,
        [`${availPrefix}.drug_type_cd`]: screenParams.drug_type_cd,
        [`${availPrefix}.drug_quantity`]: values.medication_dosage,
        [`${availPrefix}.drug_frequency`]: values.medication_frequency,
        [`${availPrefix}.actively_taking_flg`]: values.statusQuestion
      },
      action: {
        type: "screen",
        value: "MyMedicalHistory"
      },
      replaceHistory: 3
    });
  }
}

export default AddMedicationViewController;
